import {initializeErrorReporting} from './errorReporter';

initializeErrorReporting();
